var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DE1427;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.55,234.83H41.45V101.79h167.1V234.83z M168.57,153.77v-44.62c0-0.77-0.63-1.4-1.4-1.4H82.84 c-0.77,0-1.4,0.63-1.4,1.4v44.62c0,0.77,0.63,1.4,1.4,1.4h84.33C167.94,155.17,168.57,154.55,168.57,153.77z M168.57,212.23v-44.62 c0-0.77-0.63-1.4-1.4-1.4H82.84c-0.77,0-1.4,0.63-1.4,1.4v44.62c0,0.77,0.63,1.4,1.4,1.4h84.33 C167.94,213.63,168.57,213,168.57,212.23z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.47,
    y: 25.96,
    className: "st0",
    width: 95.06,
    height: 10.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.69,
    y: 3.16,
    className: "st0",
    width: 44.61,
    height: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.14,
    y: 234.83,
    className: "st0",
    width: 9.46,
    height: 5.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.66,247.93H49.07v-7.14c0-0.21,0.17-0.38,0.38-0.38h20.84c0.21,0,0.38,0.17,0.38,0.38V247.93z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.4,
    y: 234.83,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 380.269 475.2363)",
    className: "st0",
    width: 9.46,
    height: 5.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.34,247.93h21.59v-7.14c0-0.21-0.17-0.38-0.38-0.38h-20.84c-0.21,0-0.38,0.17-0.38,0.38V247.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.55,98.61H41.45V42.9c0-1.79,1.45-3.24,3.24-3.24h160.62c1.79,0,3.24,1.45,3.24,3.24V98.61z M75.39,52.86 c-9.87,0-17.86,8-17.86,17.86c0,9.87,8,17.86,17.86,17.86c9.87,0,17.86-8,17.86-17.86C93.25,60.86,85.25,52.86,75.39,52.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.21,72.1c-0.76,0.45-1.74,0.21-2.2-0.55c-0.45-0.76-0.21-1.74,0.55-2.2c0.76-0.45,1.74-0.21,2.2,0.55 C77.22,70.66,76.97,71.65,76.21,72.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.87,
    y: 52.61,
    className: "st0",
    width: 1.04,
    height: 4.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.97,54.18 68.93,53.79 70.5,57.56 69.53,57.95  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 57.31,
    transform: "matrix(0.707 -0.7073 0.7073 0.707 -23.2202 62.6711)",
    className: "st0",
    width: 1.04,
    height: 4.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.01,
    y: 62.53,
    transform: "matrix(0.3832 -0.9237 0.9237 0.3832 -22.3071 95.7421)",
    className: "st0",
    width: 1.04,
    height: 4.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.27,
    y: 70.21,
    className: "st0",
    width: 4.08,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.42,
    y: 70.21,
    className: "st0",
    width: 4.08,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.2,
    y: 64.05,
    transform: "matrix(0.9236 -0.3833 0.3833 0.9236 -17.8582 39.5199)",
    className: "st0",
    width: 4.09,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.71,
    y: 58.83,
    transform: "matrix(0.7069 -0.7073 0.7073 0.7069 -16.5544 78.7655)",
    className: "st0",
    width: 4.08,
    height: 1.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "80.28,57.56 81.84,53.79 82.8,54.18 81.24,57.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "72.71,73.31 71.84,71.86 87.23,63.24 87.59,63.84  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.01,209.65v-39.46c0-0.22,0.18-0.4,0.4-0.4h79.17c0.22,0,0.4,0.18,0.4,0.4v39.46c0,0.22-0.18,0.4-0.4,0.4 H85.41C85.19,210.05,85.01,209.87,85.01,209.65z M103.61,178.29c-0.16-1.66-1.51-2.98-3.22-2.98c-1.71,0-3.06,1.32-3.22,2.98h-0.06 v23.26h0.06c0.16,1.66,1.51,2.98,3.22,2.98c1.71,0,3.06-1.32,3.22-2.98h0.06v-23.26H103.61z M120.02,178.29 c-0.16-1.66-1.51-2.98-3.22-2.98s-3.06,1.32-3.22,2.98h-0.06v23.26h0.06c0.16,1.66,1.51,2.98,3.22,2.98s3.06-1.32,3.22-2.98h0.06 v-23.26H120.02z M136.42,178.29c-0.16-1.66-1.51-2.98-3.22-2.98c-1.71,0-3.06,1.32-3.22,2.98h-0.06v23.26h0.06 c0.16,1.66,1.51,2.98,3.22,2.98c1.71,0,3.06-1.32,3.22-2.98h0.06v-23.26H136.42z M152.83,178.29c-0.16-1.66-1.51-2.98-3.22-2.98 c-1.71,0-3.06,1.32-3.22,2.98h-0.06v23.26h0.06c0.16,1.66,1.51,2.98,3.22,2.98c1.71,0,3.06-1.32,3.22-2.98h0.06v-23.26H152.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.3,128.38c0,2.38-1.47,5.57-3.72,6.72c1.67-1.94,3.26-9.48-1.91-15.92c0.07,2.56-0.59,5.97-2.61,9.73 c1.11-5.99-4.35-12.01-2.48-16.3c-7.89,3.8-5.47,11.65-7.57,15.46c-0.9-3.46-3.22-7.4-4.51-7.87c0.8,5.84-3.93,7.68-1.95,14.62 c0,0-2.5-4.07-2.21-8.42c-7.02,9.22-1.39,21.22,5.38,23.9c-0.94-2.3-0.92-5.59,1-8.12c-0.15,2.17,1.1,4.19,1.1,4.19 c-0.98-3.45,1.37-4.36,0.97-7.26c0.64,0.23,1.79,2.19,2.24,3.91c1.04-1.89-0.16-5.79,3.76-7.68c-0.93,2.13,1.79,5.12,1.23,8.1 c1-1.87,1.33-3.56,1.3-4.84c2.57,3.2,1.78,6.95,0.95,7.91c1.12-0.57,1.85-2.16,1.85-3.34c1.08,2.29,0.98,4.99,0.16,7.13 C139.01,148.81,143.44,137.13,139.3,128.38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotelIcon);
export default __webpack_public_path__ + "static/media/kotel_icon.1458e2b39dd4b1e157b07fba5dd93cf8.svg";
export { ForwardRef as ReactComponent };